export const config = {
  SERVER_ENDPOINT: "https://localhost:4443",
  APP_ENDPOINT: "https://localhost:3000/",
};
